import { t } from '@lingui/core/macro';
import { NoddiIconButton } from 'noddi-ui-web';
import { useNavigate } from 'react-router-dom';

type Props = {
  /** The previous step; history back when omitted. */
  backPath?: string;
};

/** Back for a flow step, first in the bottom bar beside Chat — the header carries no back button then. */
export const FlowBackButton = ({ backPath }: Props) => {
  const navigate = useNavigate();
  const label = t`Back`;

  return (
    <NoddiIconButton
      iconName='ChevronLeft'
      aria-label={label}
      title={label}
      onClick={() => {
        if (backPath) {
          navigate(backPath);
          return;
        }
        navigate(-1);
      }}
    />
  );
};
